/**
 * The dashboard API publishes cost money amounts (payment records, their line
 * items and allocations, the tax-deduction profile's adjusted gross income and
 * the tax-deduction calculation) as decimal strings matching
 * `^-?(?:0|[1-9]\d*)(?:\.\d+)?$`. The costs code does arithmetic on numbers,
 * so amounts are parsed here where API records are read and serialised here
 * where amounts are written back — nowhere else.
 */

/** Read an API decimal-string amount as a number; missing or malformed → null. */
export function parseDecimalAmount(
  value: string | null | undefined,
): number | null {
  if (value == null || value.trim() === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Write a number as the API's decimal-string amount. Rounded to the cent and
 * never in exponent notation, so it always satisfies the published pattern;
 * whole amounts serialise without a fraction ("2000", "12.5", "0").
 */
export function toDecimalAmount(value: number): string {
  if (!Number.isFinite(value)) {
    throw new RangeError(`Cannot send a non-finite money amount: ${value}`);
  }
  const trimmed = value.toFixed(2).replace(/\.?0+$/, "");
  return trimmed === "-0" ? "0" : trimmed;
}
